module.exports = __webpack_public_path__ + "img/UTKODA-5.115d379f.jpg";